import type { InventoryResource } from '@repo/api-gw-sdk';

import { ConfirmationDialog } from '@/components/dialogs/confirmationDialog';
import { useDAL } from '@/contexts/useDAL';

export function RestartSensitivityAnnotationsDetection({
  open,
  onClose,
  entities,
}: {
  open: boolean;
  onClose: () => void;
  entities: InventoryResource[];
}) {
  const dal = useDAL();

  const onSave = () => {
    void Promise.all(
      entities.map((entity) =>
        dal.inventory.sensitivityAnnotations.deleteOverride(entity.id)
      )
    ).finally(onClose);
  };

  return (
    <ConfirmationDialog
      isOpen={open}
      title='Resume auto-detection for sensitivity annotations'
      description='Sensitivity annotations will be automatically detected, and your override will be removed. This could change the applied backup policies and controls.'
      onCancel={onClose}
      onConfirm={onSave}
      buttonTitle='Resume'
      buttonIconClass='material-symbols-motion-play-outline-rounded'
      confirmSnackbarText='Sensitivity annotations auto-detection resumed.'
    />
  );
}
